import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import BMI from "parog-web/utils/bmi";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

type SourceStringEnum = "withings";

export default class WeightMeasuredJournalEvent extends JournalEvent {
  static override type = "weight-measured-journal-event";

  @attr("number") declare weight: number;

  @attr("string") declare source: SourceStringEnum;

  static override validations(intl: IntlService) {
    return {
      weight: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.weight-measured-journal-event.weight"
          )
        }),
        validateNumber({
          gt: 0,
          lte: 200,
          description: intl.t(
            "validations.weight-measured-journal-event.weight"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.weight-measured-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      source: validateInclusion({
        list: ["withings"],
        allowBlank: true,
        description: intl.t("validations.weight-measured-journal-event.source")
      })
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "weightMeasuredJournalEvents"
  })
  declare patient: Patient;

  get bmi(): number | null {
    const lastHeightMeasured = this.patient.lastHeightMeasuredJournalEvent;

    if (!lastHeightMeasured) return null;
    return BMI(this.weight, lastHeightMeasured.height);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "weight-measured-journal-event": WeightMeasuredJournalEvent;
  }
}
